module.exports = __webpack_public_path__ + "static/0014-cdb2017c7ae17941efd34d4ecb617c54.png";